// Composes the timetable API namespace. Legacy flat functions are spread at the
// top level so existing call sites (Api.timetable.getTimetablebySemester, etc.)
// keep working; the legacy-refresh phase later migrates them to .legacy.
import legacy from "./timetable";
import profiles from "./schedulingProfiles";
import venues from "./venues";
import exam from "./timetables";
import invigilation from "./invigilation";
import roles from "./timetableRoles";

export default {
  ...legacy,
  legacy,
  profiles,
  venues,
  exam,
  invigilation,
  roles,
};
